var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{ref:"btn",tag:"component",class:_vm.cssClasses,attrs:{"type":_vm.type,"href":_vm.hrefValue,"to":_vm.route},on:{"click":_vm.onClicked}},[(_vm.icon)?_c('icon',{attrs:{"name":_vm.iconValue,"iconset":_vm.iconset}}):_vm._e(),(_vm.label)?_c('span',{domProps:{"textContent":_vm._s(_vm.labelValue)}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }